(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collapsible-content"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const section = document.querySelector('.collapsible-content--{{ section.id }}');
    if (!section) return;
    section.querySelectorAll('.accordion details').forEach(function(detailsEl) {
      const summaryEl = detailsEl.querySelector('summary');
      if (summaryEl) {
        summaryEl.setAttribute('aria-expanded', detailsEl.open ? 'true' : 'false');
        detailsEl.addEventListener('toggle', function() {
          summaryEl.setAttribute('aria-expanded', this.open ? 'true' : 'false');
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const root = document.getElementById('shopify-section-{{ section.id }}');
    if (!root) return;
    const wrap = root.querySelector('[data-contact-form]');
    const form = root.querySelector('#CustomContactForm-{{ section.id }}');
    const key = 'contactJustSubmitted-{{ section.id }}';

    if (form) {
      form.addEventListener('submit', function() {
        try { sessionStorage.setItem(key, '1'); } catch (e) {}
      });
    }

    function dedupe(sel) {
      const nodes = root.querySelectorAll(sel);
      if (nodes.length > 1) {
        for (let i = 0; i < nodes.length - 1; i++) nodes[i].remove();
      }
    }

    function run() {
      dedupe('[data-node="heading"]');
      dedupe('[data-node="success"]');

      const success = root.querySelector('[data-node="success"]');
      let justSubmitted = false;
      try { justSubmitted = sessionStorage.getItem(key) === '1'; } catch (e) {}

      if (wrap && wrap.classList.contains('has-success') && !justSubmitted) {
        if (success) success.remove();
        wrap.classList.remove('has-success');
        try {
          const url = new URL(window.location.href);
          url.search = '';
          history.replaceState(null, '', url.toString());
        } catch (e) {}
      } else if (wrap && wrap.classList.contains('has-success') && justSubmitted) {
        try { sessionStorage.removeItem(key); } catch (e) {}
        if (form && form.reset) form.reset();
      }
    }

    run();
    document.addEventListener('shopify:section:load', function(e) {
      if (e && e.detail && e.detail.sectionId === '{{ section.id }}') run();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function isIE() {
      const ua = window.navigator.userAgent;
      return ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0;
    }
    if (!isIE()) return;
    const noscriptWrapper = document.querySelector('.product-form__noscript-wrapper-{{ section.id }}');
    const variantSwitcher = document.querySelector('variant-radios[data-section="{{ section.id }}"]') || document.querySelector('variant-selects[data-section="{{ section.id }}"]');
    if (!noscriptWrapper || !variantSwitcher) return;
    const hiddenInput = document.querySelector('#product-form-{{ section.id }} input[name="id"]');
    const noScriptInputWrapper = document.createElement('div');
    noScriptInputWrapper.innerHTML = noscriptWrapper.textContent;
    variantSwitcher.outerHTML = noScriptInputWrapper.outerHTML;
    const variantsSelect = document.querySelector('#Variants-{{ section.id }}');
    if (variantsSelect && hiddenInput) {
      variantsSelect.addEventListener('change', function (event) {
        hiddenInput.value = event.currentTarget.value;
      });
    }
  });

  (function () {
    if (!/iP(hone|ad|od)/.test(navigator.platform) && !(navigator.userAgent.includes('Mac') && 'ontouchend' in document)) return;
    document.querySelectorAll('.product-media-container.constrain-height').forEach(function (el) {
      el.classList.remove('constrain-height');
      el.style.maxHeight = 'none';
      el.style.height = 'auto';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    function patchMediaGallery() {
      const MediaGallery = customElements.get('media-gallery');
      if (!MediaGallery || !MediaGallery.prototype) return false;

      if (typeof MediaGallery.prototype.scrollToActiveMedia === 'function') {
        MediaGallery.prototype.scrollToActiveMedia = function () {};
      }
      if (typeof MediaGallery.prototype.preventStickyHeader === 'function') {
        MediaGallery.prototype.preventStickyHeader = function () {};
      }

      MediaGallery.prototype.__autoScrollDisabled = true;
      return true;
    }

    if (!patchMediaGallery()) {
      window.addEventListener('load', patchMediaGallery, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-hotspot"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const root = document.getElementById('ImageHotspot-{{ section.id }}');
    if (!root || root.dataset.imageHotspotInitialised === 'true') return;

    root.dataset.imageHotspotInitialised = 'true';
    const hotspots = Array.from(root.querySelectorAll('[data-hotspot]'));
    if (!hotspots.length) return;

    function closeHotspots() {
      hotspots.forEach((hotspot) => {
        hotspot.classList.remove('is-active');
        const button = hotspot.querySelector('.image-hotspot__pin');
        if (button) button.setAttribute('aria-expanded', 'false');
      });
    }

    hotspots.forEach((hotspot) => {
      const button = hotspot.querySelector('.image-hotspot__pin');
      if (!button) return;

      button.addEventListener('click', function(event) {
        event.preventDefault();
        const isActive = hotspot.classList.contains('is-active');
        closeHotspots();

        if (!isActive) {
          hotspot.classList.add('is-active');
          button.setAttribute('aria-expanded', 'true');
        }
      });
    });

    document.addEventListener('click', function(event) {
      if (!root.contains(event.target)) closeHotspots();
    });

    root.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') closeHotspots();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  window.addEventListener('load', function() {
    if (typeof CustomerAddresses !== 'undefined') new CustomerAddresses();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var ua = window.navigator.userAgent;
    if (ua.indexOf('MSIE ') <= 0 && ua.indexOf('Trident/') <= 0) return;
    var cartSubmitInput = document.createElement('input');
    cartSubmitInput.setAttribute('name', 'checkout');
    cartSubmitInput.setAttribute('type', 'hidden');
    document.querySelector('#cart').appendChild(cartSubmitInput);
    document.querySelector('#checkout').addEventListener('click', function() {
      document.querySelector('#cart').submit();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  (function() {
    if (window.__smATCInit) return;
    window.__smATCInit = true;
    document.addEventListener('submit', function(e) {
      var form = e.target.closest('form.sm-atc-form[data-ajax="true"]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.disabled = true;
      var fd = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function(r) { return r.ok ? r.json() : r.json().then(Promise.reject); })
        .then(function() { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); })
        .catch(console.error)
        .finally(function() { if (btn) btn.disabled = false; });
    }, { passive: false });
  })();
  (function() {
    document.addEventListener('submit', function(e) {
      var form = e.target.closest('product-form form[action*="/cart/add"]');
      if (!form) return;
      if (e.defaultPrevented) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      var fd = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function(r) { return r.ok ? r.json() : r.json().then(Promise.reject); })
        .then(function() { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); })
        .catch(console.error)
        .finally(function() { if (btn) btn.disabled = false; });
    }, { passive: false });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    function isIE() {
      var ua = window.navigator.userAgent;
      return ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0;
    }

    if (!isIE()) return;

    var hiddenInput = document.querySelector('#{{ product_form_id }} input[name="id"]');
    var noScriptInputWrapper = document.createElement('div');
    var variantSwitcher = document.querySelector('variant-radios[data-section="{{ section.id }}"]') || document.querySelector('variant-selects[data-section="{{ section.id }}"]');
    noScriptInputWrapper.innerHTML = document.querySelector('.product-form__noscript-wrapper-{{ section.id }}').textContent;
    variantSwitcher.outerHTML = noScriptInputWrapper.outerHTML;
    document.querySelector('#Variants-{{ section.id }}').addEventListener('change', function(event) {
      hiddenInput.value = event.currentTarget.value;
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initPaginationLinks() {
      document.querySelectorAll('#rich-text-slider-{{ section.id }} .slider-counter__link[data-slide-index]').forEach(function(link) {
        if (link.dataset.initialized) return;
        link.dataset.initialized = '1';
        var sliderEl = link.closest('slider-component');
        if (!sliderEl || !sliderEl.slider) return;
        link.addEventListener('click', function() {
          var index = parseInt(link.getAttribute('data-slide-index'), 10);
          if (!sliderEl.sliderItemOffset) return;
          sliderEl.setSlidePosition(index * sliderEl.sliderItemOffset);
        });
      });
      var sliderEl = document.querySelector('#rich-text-slider-{{ section.id }} slider-component');
      if (sliderEl && !sliderEl.dataset.paginationListener) {
        sliderEl.dataset.paginationListener = '1';
        sliderEl.addEventListener('slideChanged', function(e) {
          var page = e.detail && e.detail.currentPage;
          if (!page) return;
          var wrapper = sliderEl.querySelector('.slider-counter');
          if (!wrapper) return;
          wrapper.querySelectorAll('.slider-counter__link').forEach(function(l, i) {
            l.classList.toggle('slider-counter__link--active', i === page - 1);
          });
        });
      }
    }
    if (customElements.get('slider-component')) {
      initPaginationLinks();
    } else {
      customElements.whenDefined('slider-component').then(function() { setTimeout(initPaginationLinks, 0); });
    }
    document.addEventListener('shopify:section:load', function(e) {
      if (e.detail && e.detail.sectionId === '{{ section.id }}') setTimeout(initPaginationLinks, 100);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-scroll-panels"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initStickySection(sectionEl) {
      if (!sectionEl || sectionEl.dataset.sspInit === 'true') return;

      var outer = sectionEl.querySelector('.sticky-scroll-panels__outer');
      var panels = sectionEl.querySelectorAll('.sticky-scroll-panels__panel');
      var dots = sectionEl.querySelectorAll('.sticky-scroll-panels__progress-dot');

      if (!outer || panels.length < 1) return;

      var total = panels.length;
      var lastIndex = -1;

      function isStackedMobile() {
        return window.matchMedia('(max-width: 749px)').matches;
      }

      function setActive(index) {
        if (index === lastIndex) return;
        lastIndex = index;

        for (var i = 0; i < panels.length; i++) {
          var isActive = i === index;
          panels[i].classList.toggle('is-active', isActive);
          panels[i].setAttribute('aria-hidden', isActive ? 'false' : 'true');
        }

        for (var j = 0; j < dots.length; j++) {
          dots[j].classList.toggle('is-active', j === index);
        }
      }

      function setSubProgress(scaledProgress) {
        for (var i = 0; i < panels.length; i++) {
          var sub = scaledProgress - i;
          if (sub < 0) sub = 0;
          if (sub > 1) sub = 1;
          panels[i].style.setProperty('--ssp-sub-progress', sub.toFixed(4));
        }
      }

      function resetSubProgress() {
        for (var i = 0; i < panels.length; i++) {
          panels[i].style.removeProperty('--ssp-sub-progress');
        }
      }

      function update() {
        if (isStackedMobile()) {
          resetSubProgress();
          for (var i = 0; i < panels.length; i++) {
            panels[i].classList.add('is-active');
            panels[i].setAttribute('aria-hidden', 'false');
          }
          return;
        }

        var rect = outer.getBoundingClientRect();
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        var scrollableHeight = outer.offsetHeight - viewportHeight;

        if (scrollableHeight <= 0) {
          setSubProgress(0.5);
          setActive(0);
          return;
        }

        var scrolled = -rect.top;
        if (scrolled < 0) scrolled = 0;
        if (scrolled > scrollableHeight) scrolled = scrollableHeight;

        var progress = scrolled / scrollableHeight;
        var scaledProgress = progress * total;
        var index = Math.floor(scaledProgress);
        if (index >= total) index = total - 1;
        if (index < 0) index = 0;

        setSubProgress(scaledProgress);
        setActive(index);
      }

      var ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          update();
          ticking = false;
        });
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      window.addEventListener('orientationchange', onScroll, { passive: true });

      sectionEl._sspCleanup = function () {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        window.removeEventListener('orientationchange', onScroll);
      };

      update();
      sectionEl.dataset.sspInit = 'true';
    }

    function initAll() {
      var sections = document.querySelectorAll('[id^="sticky_scroll_panels--"]');
      for (var i = 0; i < sections.length; i++) initStickySection(sections[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (e) {
        var id = e.detail && e.detail.sectionId;
        if (!id) return;
        var sectionEl = document.getElementById('sticky_scroll_panels--' + id);
        if (sectionEl) initStickySection(sectionEl);
      });

      document.addEventListener('shopify:section:unload', function (e) {
        var id = e.detail && e.detail.sectionId;
        if (!id) return;
        var sectionEl = document.getElementById('sticky_scroll_panels--' + id);
        if (sectionEl && typeof sectionEl._sspCleanup === 'function') sectionEl._sspCleanup();
      });

      document.addEventListener('shopify:block:select', function (e) {
        var detail = e.detail || {};
        var sectionEl = detail.sectionId ? document.getElementById('sticky_scroll_panels--' + detail.sectionId) : null;
        if (!sectionEl || !detail.blockId) return;

        var panels = sectionEl.querySelectorAll('.sticky-scroll-panels__panel');
        var targetIdx = -1;
        for (var i = 0; i < panels.length; i++) {
          if (panels[i].getAttribute('data-shopify-editor-block') === detail.blockId) {
            targetIdx = i;
            break;
          }
        }
        if (targetIdx < 0) return;

        var outer = sectionEl.querySelector('.sticky-scroll-panels__outer');
        if (!outer) return;

        var rect = outer.getBoundingClientRect();
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        var scrollableHeight = outer.offsetHeight - viewportHeight;
        if (scrollableHeight <= 0) return;

        var total = panels.length || 1;
        var targetProgress = (targetIdx + 0.5) / total;
        var targetScroll = window.scrollY + rect.top + targetProgress * scrollableHeight;
        window.scrollTo({ top: targetScroll, behavior: 'smooth' });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-and-image-scroll"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function setActive(sectionEl, index) {
      var navItems = sectionEl.querySelectorAll('.text__image--scroll--navigation-item');
      var mediaItems = sectionEl.querySelectorAll('.text__image--scroll--media-item');
      navItems.forEach(function(el, i) { el.classList.toggle('active', i === index); });
      mediaItems.forEach(function(el, i) { el.classList.toggle('is-active', i === index); });
    }

    function initSection(sectionEl) {
      if (!sectionEl || sectionEl.dataset.scrollInit === 'true') return;
      var navItems = sectionEl.querySelectorAll('.text__image--scroll--navigation-item');
      var mediaItems = sectionEl.querySelectorAll('.text__image--scroll--media-item');
      if (mediaItems.length === 0) return;

      var mediaEl = sectionEl.querySelector('.text__image--scroll--media');
      var progressBar = sectionEl.querySelector('.text_image_scroll__progress .grid-carousel-progress-bar');
      var isMobile = function() { return window.innerWidth <= 767; };

      function updateProgressBar() {
        if (!progressBar || !mediaEl || !isMobile()) return;
        var maxScroll = mediaEl.scrollWidth - mediaEl.clientWidth;
        var rate = maxScroll <= 0 ? 1 : Math.min(mediaEl.scrollLeft / maxScroll, 1);
        progressBar.style.width = (100 * rate) + '%';
      }

      function scrollToIndex(index) {
        var list = sectionEl.querySelectorAll('.text__image--scroll--media-item');
        index = Math.max(0, Math.min(index, list.length - 1));

        var slide = list[index];
        if (!slide || !mediaEl) return;

        var targetScroll = slide.offsetLeft;

        if (mediaEl.scrollTo) {
          mediaEl.scrollTo({
            left: targetScroll,
            behavior: 'smooth'
          });
        } else {
          mediaEl.scrollLeft = targetScroll;
        }

        setActive(sectionEl, index);

        if (isMobile() && progressBar) {
          var maxScroll = mediaEl.scrollWidth - mediaEl.clientWidth;
          progressBar.style.width = (maxScroll <= 0 ? 100 : (100 * targetScroll / maxScroll)) + '%';
        }

        if (isMobile()) updateArrowState();
      }

      mediaItems.forEach(function(slide, index) {
        new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.3) {
              setActive(sectionEl, index);
            }
          });
        }, { threshold: [0.3, 0.5, 0.8] }).observe(slide);
      });

      var totalSlides = mediaItems.length;

      function updateArrowState() {
        var prevBtn = sectionEl.querySelector('.text__image--scroll--media-arrows .slider-button--prev');
        var nextBtn = sectionEl.querySelector('.text__image--scroll--media-arrows .slider-button--next');
        var activeNav = sectionEl.querySelector('.text__image--scroll--navigation-item.active');
        var idx = activeNav ? Array.prototype.indexOf.call(navItems, activeNav) : 0;
        if (prevBtn) prevBtn.disabled = idx <= 0;
        if (nextBtn) nextBtn.disabled = idx >= totalSlides - 1;
      }

      if (mediaEl) {
        mediaEl.addEventListener('scroll', function() {
          if (isMobile()) updateProgressBar();
          var items = sectionEl.querySelectorAll('.text__image--scroll--media-item');
          var container = mediaEl;
          var scrollCenter = container.scrollLeft + container.clientWidth / 2;
          var activeIndex = 0;
          items.forEach(function(item, i) {
            var left = item.offsetLeft;
            var right = left + item.offsetWidth;
            if (scrollCenter >= left && scrollCenter <= right) activeIndex = i;
          });
          setActive(sectionEl, activeIndex);
          if (isMobile()) updateArrowState();
        });
        if (typeof ResizeObserver !== 'undefined') {
          new ResizeObserver(function() { if (isMobile()) updateProgressBar(); }).observe(mediaEl);
        }
      }

      sectionEl.querySelectorAll('.text__image--scroll--navigation-item').forEach(function(navItem, index) {
        navItem.addEventListener('click', function() {
          scrollToIndex(index);
        });
      });

      if (isMobile()) {
        updateProgressBar();
        updateArrowState();
      }
      sectionEl.dataset.scrollInit = 'true';
    }

    function initAll() {
      var sections = document.querySelectorAll('[id^="text_image_scroll--"]');
      sections.forEach(function(s) { initSection(s); });
    }

    if (document.readyState === 'loading') {
      window.addEventListener('load', initAll);
    } else {
      initAll();
    }

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function(e) {
        var sectionEl = e.detail && e.detail.sectionId
          ? document.getElementById('text_image_scroll--' + e.detail.sectionId)
          : null;
        if (sectionEl) initSection(sectionEl);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
